import { COLLECTION_GET } from '@annunciate/query/dist/queries/collection';
import { useQuery } from './base';
export const useCollectionQuery = (id) => {
    return useQuery(['collection'], COLLECTION_GET, { id });
};
//# sourceMappingURL=useCollectionQuery.js.map